export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const FAIL = '_FAIL';
export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const PATCH = 'PATCH';
export const DELETE = 'DELETE';

export const SET_STEP = 'SET_STEP';
export const API_ERROR = 'API_ERROR';
export const API_CLEAR_ERROR = 'API_CLEAR_ERROR';
